import React, { useState } from 'react';
import { API_BASE_URL } from '../api/config';


function GroupActions({ groupId, username, isOwner, groupStatus, onUpdate }) {
  const [confirmedDate, setConfirmedDate] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [error, setError] = useState('');

  const handleConfirmDate = async () => {
    if (!confirmedDate) {
      setError('날짜를 선택해주세요');
      return;
    }

    try {
      const res = await fetch(`${API_BASE_URL}/api/groups/${groupId}/confirm?confirmer=${username}&confirmedDate=${confirmedDate}`, {
        method: 'POST'
      });
      
      if (res.ok) {
        alert('공구 날짜가 확정되었습니다! 🎉');
        setShowConfirmModal(false);
        if (onUpdate) onUpdate();
      } else {
        const data = await res.json();
        setError(data.error || '날짜 확정 실패');
      }
    } catch (e) {
      setError('날짜 확정 실패');
    }
  };

  const handleComplete = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/groups/${groupId}/complete?completer=${username}`, {
        method: 'POST'
      });
      
      if (res.ok) {
        alert('공구가 완료되었습니다! 이제 서로를 평가해주세요.');
        setShowCompleteModal(false);
        if (onUpdate) onUpdate();
      } else {
        const data = await res.json();
        setError(data.error || '완료 처리 실패');
      }
    } catch (e) {
      setError('완료 처리 실패');
    }
  };

  // 모집 중일 때만 날짜 확정 버튼 표시
  if (groupStatus === 'OPEN' && isOwner) {
    return (
      <div style={{ marginBottom: 16 }}>
        <button
          type="button"
          className="app-btn"
          onClick={() => setShowConfirmModal(true)}
          style={{ width: '100%' }}
        >
          공구 날짜 확정하기
        </button>

        {showConfirmModal && (
          <div className="ga-modal-backdrop">
            <div className="ga-modal">
              <h3>공구 날짜 확정</h3>
              <p>참여자들과 합의한 공구 날짜를 선택해주세요.</p>
              <input
                className="app-input"
                type="date"
                value={confirmedDate}
                onChange={(e) => setConfirmedDate(e.target.value)}
                style={{ marginBottom: 12 }}
              />
              {error && <div className="app-error" style={{ marginBottom: 8 }}>{error}</div>}
              <div style={{ display: 'flex', gap: 8 }}>
                <button type="button" className="app-btn" onClick={handleConfirmDate}>확정</button>
                <button type="button" className="app-btn secondary" onClick={() => setShowConfirmModal(false)}>취소</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // 날짜 확정된 상태일 때만 완료 버튼 표시
  if (groupStatus === 'CONFIRMED' && isOwner) {
    return (
      <div style={{ marginBottom: 16 }}>
        <button
          type="button"
          className="app-btn"
          onClick={() => setShowCompleteModal(true)}
          style={{ width: '100%', background: '#d97706' }}
        >
          공구 완료하기
        </button>

        {showCompleteModal && (
          <div className="ga-modal-backdrop">
            <div className="ga-modal">
              <h3>공구 완료</h3>
              <p>공구가 성공적으로 완료되었나요? 완료하면 참여자들이 서로를 평가할 수 있습니다.</p>
              {error && <div className="app-error" style={{ marginBottom: 8 }}>{error}</div>}
              <div style={{ display: 'flex', gap: 8 }}>
                <button type="button" className="app-btn" onClick={handleComplete}>완료</button>
                <button type="button" className="app-btn secondary" onClick={() => setShowCompleteModal(false)}>취소</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return null;
}

export default GroupActions;
